/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import SelectDateFilter from 'modules/common/components/SelectDateFilter';
import PropTypes from 'prop-types';
import withDashboard from '../../../common/hoc/withDashboard';

import * as actions from '../action';
import * as c from '../constant';
import OhpChartComponent from '../components/OhpChartComponent';

const colors = ['#5272AA ', '#7790CB ', '#8AA4F8 ', '#A3B3F9 '];

const optionList = [
  { label: 'INDIVIDUAL', value: 'INDIVIDUAL' },
  { label: 'CORPORATION', value: 'CORPORATION' },
];

const rename = (obj, oldKey, newKey) => {
  if (_.has(obj, oldKey)) {
    _.set(obj, newKey, _.get(obj, oldKey));
    _.unset(obj, oldKey);
  }
  return obj;
};

const filter = {
  transaction_type: 'ALL',
};

function OhpDashboardContainer({
  graphStats,
  getGraphStats,
}) {
  const [filterData, setFilterData] = useState(filter);
  const [isLoading, setIsLoading] = useState(true);

  const renderLegends = (dt) =>
    dt.map((x) => {
      return (
        <div key={x.name} className="legend-item">
          <div
            style={{
              background: `${x.color}`,
              width: 20,
              height: 20,
              marginRight: 20,
            }}
          />
          <div className="legend-text">{x.name}</div>
        </div>
      );
    });

  const handleOnSubmit = (data) => {
    const args = {
      ...data,
      permit_type: 'Occupational Permit / Health Certificate',
    }
    getGraphStats(args);
  };

  // const handleOnSubmit = ({ type, from, to }) => {
  //   // eslint-disable-next-line no-console
  //   getGraphStats({
  //     period: type,
  //     date_from: from,
  //     date_to: to,
  //     permit_type: 'Occupational Permit / Health Certificate',
  //   });
  // };

  const handleChangeSelect = (e) => {
    setFilterData({
      ...filterData,
      transaction_type: e ? e.value : '',
    });
  };

  const formatKey = [
    {
      key: 'INDIVIDUAL',
      color: `${colors[0]}`,
    },
    {
      key: 'CORPORATION',
      color: `${colors[1]}`,
    },
  ];

  useEffect(() => {
    getGraphStats();
    setIsLoading(false);
    return () => {
      setIsLoading(false);
    };
  }, []);

  return (
    <div className="dashboard-card">
      <div className="row mb-3">
        <div className="col-12">
          <div className="main-text">Statistics</div>
        </div>
        <div className="col-12">
          <SelectDateFilter onSubmit={handleOnSubmit} />
        </div>
        <div className="col-12">
          <OhpChartComponent
            chartData={graphStats}
          />
        </div>
        <div className="legends-wrapper area px-3 w-100">
          <div
            className="render-chart-legends"
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'row',
              flexWrap: 'wrap',
            }}
          >
            {renderLegends(c.LEGENDS)}
          </div>
        </div>
      </div>
    </div>
  );
}

OhpDashboardContainer.propTypes = {
  graphStats: PropTypes.instanceOf(Object).isRequired,
  getGraphStats: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  graphStats: _.get(api, `${c.GET_GRAPH_STATS}.list`) || [],
});

const enhance = _.flowRight([
  withDashboard,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(OhpDashboardContainer);
